<div class="er-kyc-ok" *ngIf="!is2FA">
    <span class="material-icons er-modal-icon">verified_user</span>
    <h5 class="er-kyc-ok-title">eKYC completed</h5>
    <p class="er-kyc-ok-msg">Congrats! Your eKYC has been done successfully. Click OK to continue.</p>
    <div class="er-kyc-ok-actions">
        <button type="button" class="er-btn er-btn--primary" (click)="closeModal()">OK</button>
    </div>
</div>

<div class="er-kyc-ok" *ngIf="is2FA">
    <span class="material-icons er-modal-icon">verified_user</span>
    <h5 class="er-kyc-ok-title">Two-factor authentication complete</h5>
    <p class="er-kyc-ok-msg">Congrats! Your two-factor authentication has been done successfully. Click OK to continue.</p>
    <div class="er-kyc-ok-actions">
        <button type="button" class="er-btn er-btn--primary" (click)="closeModal2fa()">OK</button>
    </div>
</div>
